import * as React from 'react';
import { translate } from 'components/translate-hoc';
import GameInstaller from 'modules/game-installer';
import { ISuccessProps } from './success.types';
import { TEXT_KEYS, SUCCESS_DISPLAY_FLOW_STEP, SUCCESS_DISPLAY_ACTION } from './success.constants';
import { ConfigContext } from 'modules/context';
import { onImageError } from './success.utils';
import AnalyticsService from 'modules/analytics-provider/analytics-provider.service';
import { CATEGORY } from 'modules/analytics-provider/analytics-provider.constants';

import './success.styles.less';

class Success extends React.PureComponent<ISuccessProps> {
    public componentDidMount() {
        AnalyticsService.sendFlowEvent({
            ...SUCCESS_DISPLAY_FLOW_STEP,
            action: SUCCESS_DISPLAY_ACTION,
            category: CATEGORY.DISPLAY
        });
    }

    public render(): JSX.Element {
        const {
            contentGameItem: {
                packId,
                name,
                imageSrc,
            },
            dangerouslyTranslateWithHTML: translateKey
        } = this.props;
        const { getModeClass } = this.context;
        return (
            <div className={getModeClass('sitegen-redeem-success')}>
                <div className="sitegen-redeem-success__content">
                    <div className="sitegen-redeem-success__content-title">
                        {translateKey(TEXT_KEYS.REDEEM_SUCCESS_TITLE)}
                    </div>

                    {imageSrc && <div className="sitegen-redeem-success__image-block">
                        <img onError={onImageError} src={imageSrc as string} alt=""/>
                    </div>}

                    {name && <div className="sitegen-redeem-success__content-message">
                        {translateKey(TEXT_KEYS.REDEEM_SUCCESS_CONGRATS_MESSAGE, {
                            item: name
                        })}
                    </div>}

                    <GameInstaller
                        gameId={String(packId)}
                        hasBrandedInstaller={false}
                        direction="row"
                        analyticsActionPrefix={`${SUCCESS_DISPLAY_FLOW_STEP.flowStep} : `}
                    />
                </div>
            </div>
        );
    }
}

Success.contextType = ConfigContext;

export default translate()(Success);
